import createFormValues from './createFormValues';
import plain from './structure/plain';

export default createFormValues(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/formValues.js
// module id = 1152
// module chunks = 0